import React from 'react';
import { useSelector } from 'react-redux';
import WidgetBase from '../_base';
import Filters from '../_filters';

export const UnknownWidget = ({ defaultProps, id, item, setItem }) => {
    const showFilters = useSelector(state => state.ui.filterWidget);

    const height = defaultProps.height(item);

    const user = {};

    const chart = (
        <div className="chart-container" style={{ height: `${height}px` }}>
            UNKNOWN WIDGET
        </div>
    );

    const recommendations = <div>NO RECOMMENDATIONS AVAILABLE FOR THIS WIDGET</div>;

    const filters = (
        <Filters
            widget={item}
            values={{}}
            errors={{}}
            //onChange={(value, prop) => updateProperty(value, prop)}
            refresh={x => {
                setItem(x);
            }}
            show={showFilters === id}
            reload={null}
        >
            <div>Unknow widget</div>
        </Filters>
    );

    return (
        <WidgetBase
            filters={filters}
            chart={chart}
            height={height}
            item={item}
            recommendations={recommendations}
            id={id}
            help={null}
            hideConfig={defaultProps.company && !user.administrator}
            extra={null}
            loading={false}
            notConfigured={false}
        />
    );
};

export default UnknownWidget;
